function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "6");

var _ref2 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "min");

function SvgIcn6Min({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": 6,
    transform: "translate(12 23.08)",
    style: {
      fontSize: 24,
      fill: "#5e5e5d",
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref), /*#__PURE__*/React.createElement("text", {
    transform: "translate(11 35.95)",
    style: {
      fontSize: 10,
      fill: "#5e5e5d",
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref2)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn6Min);
export default __webpack_public_path__ + "static/media/icn-6min.aa680eb6f8cf768c1f6cb7a33e86cf6c.svg";
export { ForwardRef as ReactComponent };